import { useAppSelector } from '../useAppSelector';
import { useLookups } from '../useLookups';
import * as lookupSlice from '../../data/lookup.slice';

export const useAlternateContactType = (
  alternateContactBC: string | undefined,
): string => {
  useLookups(['alternateContactType']);
  const types = useAppSelector(lookupSlice.selectAlternateContactTypes);
  const type = types.find(
    (s) => s.alternateContactTypeBC === alternateContactBC,
  );
  return type ? type.alternateContactTypeName : '';
};
